export default __webpack_public_path__ + "static/media/logo-tokorame.d7ccf59f.svg";